let uuid = 0;
import { screens } from "@utils/tailwind";

export default {
  state: () => ({
    modals: [],
    bgColor: "white",
    fgColor: "brown",
    deviceWidth: 750,
    dpr: 2,
    isMobile: true,
    menuOpen: false
  }),
  mutations: {
    /**
     * Add modal to app
     * @param {*} state
     * @param {*} payload
     */
    addModal(state, payload) {
      state.modals.push({ uuid, ...payload });
      uuid += 1;
    },

    /**
     * Remove modal from app
     * @param {*} state
     * @param {*} payload
     */
    removeModal(state, payload) {
      const i = state.modals.findIndex(modal => modal.uuid === payload);
      state.modals.splice(i, 1);
    },

    /**
     * Remove all modals from app
     * @param {*} state
     */
    removeAllModals(state) {
      state.modals = [];
    },

    /**
     * Set app theme (fg and bg color)
     * @param {*} state
     * @param {*} payload
     */
    setTheme(state, payload) {
      state.bgColor = payload.bgColor;
      state.fgColor = payload.fgColor;
    },

    /**
     * isMobile
     * @param {*} state
     */
    setIsMobile(state) {
      state.isMobile =
        window.innerWidth <
        parseInt(
          screens().find(breakpoint => breakpoint.handle === "lg").width
        );
    },

    /**
     * Set device inner width
     * @param {*} state
     */
    setDeviceWidth(state) {
      state.deviceWidth = window.innerWidth;
    },

    /**
     * Set device DPR
     * @param {*} state
     */
    setDpr(state) {
      state.dpr = window.devicePixelRatio;
    },

    /**
     * Management of mobile menu openness amd side effects
     * @param {*} state
     * @param {*} payload
     */
    setMenuOpen(state, payload) {
      state.menuOpen = payload;
      document.body.classList[payload ? "add" : "remove"]("overflow-hidden");
    }
  },

  actions: {
    setResizeHandlers({ commit }) {
      commit("setIsMobile");
      commit("setDeviceWidth");
      commit("setDpr");
    }
  }
};
